export const TemplateSchema = {
    enabled: 'enabled',
    messageData: 'messageData',
    messageDataSchema: {
        subject: 'subject',
        bcc: 'bcc',
        to: 'to',
        body: 'body',
        shortBody: 'shortBody'
    },
    admins: 'admins',
    users: 'users'
}